export class ContactMethods {
  static EMAIL = 'EMAIL'
  static PHONE = 'PHONE'
  static TEXT = 'TEXT'
  static VIDEO_CONFERENCE = 'VIDEO_CONFERENCE'
}
